//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { BooleanResultDTO } from 'src/app/core/interfaces/general/boolean-result';
import { BooleanWithStringArrayResultDTO } from 'src/app/core/interfaces/general/boolean-with-string-array-result';
import { DateResultDTO } from 'src/app/core/interfaces/general/date-result';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { IntegerResultDTO } from 'src/app/core/interfaces/general/integer-result';
import { LicenceCompanyAllocatedDTO } from 'src/app/core/models/system/licence/licence-company-allocated.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class LicencesCompanyAllocatedService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
  
  public calculateCancellationDate(licenceAllocatedId: number, companyId: number): Observable<DateResultDTO> {
    try {
      return forkJoin({
               licenceAllocatedIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceAllocatedId),
               companyIdEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             })
             .pipe(
               switchMap(({ licenceAllocatedIdEncResult, companyIdEncResult }) => {
                 const licenceAllocatedIdEnc=licenceAllocatedIdEncResult.result;
                 const companyIdEncSS       =companyIdEncResult.result;
                 
                 return this.httpClientService.get<DateResultDTO>(environment.eSimApi + 
                                                                  eSimApiPaths.LicencesCompanyAllocated + '/' +
                                                                  eSimApiPaths.LicencesCompanyAllocatedCalculateCancellationDate +
                                                                  "?licenceAllocatedIdEnc=" + licenceAllocatedIdEnc +
                                                                  "&companyIdEncSS=" + companyIdEncSS,
                                                                  {}
                                                                 );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public cancelLicence(licenceAllocatedId: number, companyId: number): Observable<Boolean> {
    try {
      return forkJoin({
               licenceAllocatedIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceAllocatedId),
               companyIdEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             })
             .pipe(
               switchMap(({ licenceAllocatedIdEncResult, companyIdEncResult }) => {
                 const licenceAllocatedIdEnc=licenceAllocatedIdEncResult.result;
                 const companyIdEncSS       =companyIdEncResult.result;
                 
                 return this.httpClientService.post(environment.eSimApi + 
                                                    eSimApiPaths.LicencesCompanyAllocated + '/' +
                                                    eSimApiPaths.LicencesCompanyAllocatedCancelLicence +
                                                    "?licenceAllocatedIdEnc=" + licenceAllocatedIdEnc +
                                                    "&companyIdEncSS=" + companyIdEncSS,
                                                    {}
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public changeQuantityAndStartDate(licenceAllocatedId: number, companyId: number, quantity: number, startDate: Date | undefined): Observable<Boolean> {
    try {
      return forkJoin({
               licenceAllocatedIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceAllocatedId),
               companyIdEncResult         : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             })
             .pipe(
               switchMap(({ licenceAllocatedIdEncResult, companyIdEncResult }) => {
                 const licenceAllocatedIdEnc=licenceAllocatedIdEncResult.result;
                 const companyIdEncSS       =companyIdEncResult.result;
                 const startDateParam       =startDate ? "&startDate=" + encodeURIComponent(startDate.toISOString().substring(0, 10)) : "";

                 return this.httpClientService.post(environment.eSimApi +
                                                    eSimApiPaths.LicencesCompanyAllocated + '/' +
                                                    eSimApiPaths.LicencesCompanyAllocatedChangeQuantityAndStartDate +
                                                    "?licenceAllocatedIdEnc=" + licenceAllocatedIdEnc +
                                                    "&companyIdEncSS="        + companyIdEncSS +
                                                    "&quantity="              + quantity +
                                                    startDateParam,
                                                    {}
                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public companyHasLicenceBundle(companyId: number, licenceId: number): Observable<BooleanResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               licenceIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceId)
             })
             .pipe(
               switchMap(({ companyIdEncResult, licenceIdEncResult }) => {
                 const companyIdEncSS=companyIdEncResult.result;
                 const licenceIdEnc  =licenceIdEncResult.result;
                 
                 return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                     eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                     eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicenceBundle +
                                                                     "?companyIdEncSS=" + companyIdEncSS +
                                                                     "&licenceIdEnc=" + licenceIdEnc
                                                                    );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public companyHasLicenceFeature(companyId: number, licenceId: number): Observable<BooleanResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               licenceIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceId)
             })
             .pipe(
               switchMap(({ companyIdEncResult, licenceIdEncResult }) => {
                 const companyIdEncSS=companyIdEncResult.result;
                 const licenceIdEnc  =licenceIdEncResult.result;
                 
                 return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                     eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                     eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicenceFeature +
                                                                     "?companyIdEncSS=" + companyIdEncSS +
                                                                     "&licenceIdEnc=" + licenceIdEnc
                                                                    );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public companyHasLicenceFeatureByGuid(companyId: number, featureGuid: string): Observable<BooleanResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
               switchMap((encResult: StringResultDTO) => {
                 const companyIdEncSS=encResult.result;
                 const guidParam     =encodeURIComponent(featureGuid);
                 
                 return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                     eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                     eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicenceFeatureByGuid +
                                                                     "?companyIdEncSS=" + companyIdEncSS +
                                                                     "&guid="           + guidParam
                                                                    );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);

      return of(<BooleanResultDTO>{ result: false });
    }
  }

  public companyHasLicencePlatform(companyId: number, licenceId: number): Observable<BooleanResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               licenceIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceId)
             })
             .pipe(
               switchMap(({ companyIdEncResult, licenceIdEncResult }) => {
                 const companyIdEncSS=companyIdEncResult.result;
                 const licenceIdEnc  =licenceIdEncResult.result;
                 
                 return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                     eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                     eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicencePlatform +
                                                                     "?companyIdEncSS=" + companyIdEncSS +
                                                                     "&licenceIdEnc=" + licenceIdEnc
                                                                    );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public companyHasLicenceUsage(companyId: number, licenceId: number): Observable<BooleanResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               licenceIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceId)
             })
             .pipe(
               switchMap(({ companyIdEncResult, licenceIdEncResult }) => {
                 const companyIdEncSS=companyIdEncResult.result;
                 const licenceIdEnc  =licenceIdEncResult.result;

                 return this.httpClientService.get<BooleanResultDTO>(environment.eSimApi +
                                                                     eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                     eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicenceUsage +
                                                                     "?companyIdEncSS=" + companyIdEncSS +
                                                                     "&licenceIdEnc=" + licenceIdEnc
                                                                    );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public companyHasLicenceUsageZoneOverlap(companyId: number, licenceId: number): Observable<BooleanWithStringArrayResultDTO> {
    try {
      return forkJoin({
               companyIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               licenceIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>licenceId)
             })
             .pipe(
               switchMap(({ companyIdEncResult, licenceIdEncResult }) => {
                 const companyIdEncSS=companyIdEncResult.result;
                 const licenceIdEnc  =licenceIdEncResult.result;

                 return this.httpClientService.get<BooleanWithStringArrayResultDTO>(environment.eSimApi +
                                                                                    eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                                    eSimApiPaths.LicencesCompanyAllocatedCompanyHasLicenceUsageZoneOverlap +
                                                                                    "?companyIdEncSS=" + companyIdEncSS +
                                                                                    "&licenceIdEnc=" + licenceIdEnc
                                                                                   );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public delete(id: number): Observable<LicenceCompanyAllocatedDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                 eSimApiPaths.LicencesCompanyAllocated +
                                                                 "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getById(id: number): Observable<LicenceCompanyAllocatedDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.LicencesCompanyAllocated +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLicencesCompanyAllocatedForHierarchy(companyId: number): Observable<LicenceCompanyAllocatedDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<LicenceCompanyAllocatedDTO[]>(environment.eSimApi +
                                                                                            eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                                            eSimApiPaths.LicencesCompanyAllocatedForHierarchy +
                                                                                            "?companyIdEncSS=" + companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLicencesCompanyAllocatedForSingleCompany(companyId: number): Observable<LicenceCompanyAllocatedDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<LicenceCompanyAllocatedDTO[]>(environment.eSimApi +
                                                                                            eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                                            eSimApiPaths.LicencesCompanyAllocatedForSingleCompany +
                                                                                            "?companyIdEncSS=" + companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(licenceCompanyAllocated: LicenceCompanyAllocatedDTO): Observable<LicenceCompanyAllocatedDTO> {
    try {
      //JSON.stringify(licenceCompanyAllocated)
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceCompanyAllocated), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.LicencesCompanyAllocated +
                                                               "?objectEncSS=" + objectEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(licenceCompanyAllocated: LicenceCompanyAllocatedDTO): Observable<LicenceCompanyAllocatedDTO> {
    try {
      //JSON.stringify(licenceCompanyAllocated)
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(licenceCompanyAllocated), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.LicencesCompanyAllocated +
                                                              "?id=" + licenceCompanyAllocated.id +
                                                              "&objectEncSS=" + objectEncSS, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(licenceCompanyAllocated: LicenceCompanyAllocatedDTO): Observable<LicenceCompanyAllocatedDTO> {
    try {
      //JSON.stringify(licenceCompanyAllocated);

      if (licenceCompanyAllocated.id && <number>licenceCompanyAllocated.id>0)
        return this.put(licenceCompanyAllocated);
      
      return this.post(licenceCompanyAllocated);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public totalLivePlatformLicencesForCompany(companyId: number): Observable<IntegerResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.getByDescription(environment.eSimApi +
                                                                           eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                           eSimApiPaths.LicencesCompanyAllocatedTotalLivePlatformLicencesForCompany +
                                                                           "?companyIdEncSS=", companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public totalLivePlatformLicencesForCompanyExcludeEnded(companyId: number): Observable<IntegerResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.getByDescription(environment.eSimApi +
                                                                           eSimApiPaths.LicencesCompanyAllocated + "/" +
                                                                           eSimApiPaths.LicencesCompanyAllocatedTotalLivePlatformLicencesForCompanyExcludeEnded +
                                                                           "?companyIdEncSS=", companyIdEncSS); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
